<template>
  <div class="Homework">
    <div class="side_list">
          <div class="homework-header">
      <el-date-picker
        v-model="value2"
        type="month"
        class="homework-month-picker"
        :placeholder="$t('homework.selectMonth')"
        value-format="yyyy-MM"
        clearable
        :append-to-body="true"
        popper-class="homework-date-popper"
        @change="get_time">
      </el-date-picker>
    </div>
      <div class="homework_box" v-if="homeworkList && homeworkList.length">
        <div @click="clickHomeworkItem(homework, index)" v-for="(homework, index) in homeworkList" :key="index" class="homework_item" :class="activeItem == index ? 'activeItemClass':''">
          <p style="font-size: 16px;word-break: break-all;">{{homework.title}}</p>
          <span class="homework_btn"
                :style="{
                  backgroundColor:utils.getHomeworkColor(homework.status)[1],
                  color:utils.getHomeworkColor(homework.status)[0],
                  borderColor:utils.getHomeworkColor(homework.status)[0]}
          ">{{ $t(utils.getHomeworkColor(homework.status)[2]) }}</span>
        </div>
      </div>
    </div>
    <div class="homework_main" v-if="homework && homeworkList && homeworkList.length">
      <h3 class="homework_title">{{homework.title}} <span class="homework_btn"
                                                          :style="{
                  backgroundColor:utils.getHomeworkColor(homework.status)[1],
                  color:utils.getHomeworkColor(homework.status)[0],
                  borderColor:utils.getHomeworkColor(homework.status)[0]}
          ">{{ $t(utils.getHomeworkColor(homework.status)[2]) }}</span></h3>
      <p class="homework_time">{{ $t('homework.homeworkTime', { start: homework.start_time, end: homework.end_time }) }}</p>
      <span class="homework_des" v-html="homework.description"></span>
      <div class="homework_attach_list">
        <div
          class="homework_study_img homework_media_card"
          v-if="homework.preview_url || homework.download_url"
          @mouseenter="showUtilsAttach = 'doc'"
          @mouseleave="showUtilsAttach = ''"
        >
        <div class="homework_media_icon is-word">
            <img class="homework_attach_thumb" src="../../assets/homework/word.png" alt="">
            <p>{{ $t('homework.viewWord') }}</p>
          </div>
          <div class="homework_study_model" v-show="showUtilsAttach === 'doc'">
            <span style="margin-bottom: 10px" @click="toPreView('',2,'p')">
              <i class="el-icon-view"></i>{{ $t('homework.preview') }}
            </span>
            <span @click="toPreView('',2,'d')">
              <i class="el-icon-download"></i>
              {{ $t('homework.download') }}
            </span>
          </div>
        </div>
        <div
          class="homework_study_img homework_media_card"
          v-if="homework.video_attach"
          @mouseenter="showUtilsAttach = 'video'"
          @mouseleave="showUtilsAttach = ''"
        >
          <div class="homework_media_icon is-video">
            <img class="homework_attach_thumb" src="../../assets/homework/video2.png" alt="">
            <p>{{ $t('homework.viewVideo') }}</p>
          </div>
          <div class="homework_study_model" v-show="showUtilsAttach === 'video'">
            <span style="margin-bottom: 10px" @click="toPreView(resolveHomeworkMediaUrl(homework.video_attach), 3)">
              <i class="el-icon-view"></i>{{ $t('homework.preview') }}
            </span>
            <span @click="downloadHomeworkMedia(homework.video_attach)">
              <i class="el-icon-download"></i>
              {{ $t('homework.download') }}
            </span>
          </div>
        </div>
        <div
          class="homework_study_img homework_media_card"
          v-if="homework.audio_attach"
          @mouseenter="showUtilsAttach = 'audio'"
          @mouseleave="showUtilsAttach = ''"
        >
          <div class="homework_media_icon is-audio">
            <img class="homework_attach_thumb" src="../../assets/homework/audio.png" alt="">
            <p>{{ $t('homework.listenAudio') }}</p>
          </div>
          <div class="homework_study_model" v-show="showUtilsAttach === 'audio'">
            <span style="margin-bottom: 10px" @click="toPreView(resolveHomeworkMediaUrl(homework.audio_attach), 4)">
              <i class="el-icon-view"></i>{{ $t('homework.preview') }}
            </span>
            <span @click="downloadHomeworkMedia(homework.audio_attach)">
              <i class="el-icon-download"></i>
              {{ $t('homework.download') }}
            </span>
          </div>
        </div>
      </div>
      <h3 class="myask">{{ $t('homework.myAnswer') }}</h3>
      <div v-if="edit">
        <el-input
          type="textarea"
          :placeholder="$t('homework.enterContent')"
          v-model="textarea"
          show-word-limit
          class="textarea"

        />
        <h3 class="myask">{{ $t('homework.addImage') }} <span style="font-size: 14px;">{{ $t('homework.fileSizeLimit') }}</span> </h3>
        <div class="add_img_box">
          <div class="add_img_item" v-for="(item,index) in attach_jpg" :key="index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false">
            <img :src="item.download_url" alt="">
            <div class="add_model" v-show="showFileUtils == item.file_id">
              <span><i class="el-icon-view" @click="toPreView(item.download_url,1)"></i></span>
              <span style="display: inline-block;margin: 0 15px">|</span>
              <span><i class="el-icon-delete" @click="delFile(item,1)"></i></span>
            </div>
          </div>
          <div class="add_img_item" >
            <el-upload
              :action="updataAction"
              :headers="headers"
              :show-file-list="false"
              accept=".png, .jpg, .jpeg"
              :http-request="Upload">
              <img style="display: block;margin: 0 auto" src="../../assets/homework/upfile.png" alt="">
              {{ $t('homework.clickUpload') }}
            </el-upload>

          </div>
        </div>
        <h3 class="myask">{{ $t('homework.addDocument') }} <span style="font-size: 14px;">{{ $t('homework.fileSizeLimit') }}</span> </h3>
        <div class="add_img_box">
          <div class="add_img_item pad15" v-for="(item,index) in attach_doc" :key="index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false">

            <template v-if="item.file_id && item.download_url">
              <img v-if="item.download_url.slice(-3).indexOf('doc') != -1" src="../../assets/homework/doc.png" alt="">
              <img v-if="item.download_url.slice(-4).indexOf('docx') != -1" src="../../assets/homework/docx.png" alt="">
              <img v-if="item.download_url.slice(-3).indexOf('pdf') != -1" src="../../assets/homework/pad_2.png" alt="">
              <span>{{getFileNameFromUrl(item.download_url)}}</span>
              <div class="add_model" v-show="showFileUtils == item.file_id">
                <span>
                  <i class="el-icon-view" @click="toPreView(item,2)"></i>
                </span>
                <span style="display: inline-block;margin: 0 15px">|</span>
                <span><i class="el-icon-delete" @click="delFile(item,2)"></i></span>
              </div>
            </template>
            <template v-else>
              {{ $t('homework.transcoding') }}
            </template>
          </div>
          <div class="add_img_item">
            <el-upload
              :action="updataAction"
              :headers="headers"
              :show-file-list="false"
              accept=".doc, .docx, .pdf"
              :on-progress="getProgress"
              :http-request="Upload2">
              <img style="display: block;margin: 0 auto" src="../../assets/homework/upfile.png" alt="">
              {{ $t('homework.clickUpload') }}
            </el-upload>
          </div>
        </div>
        <h3 class="myask">{{ $t('homework.addVideo') }} <span style="font-size: 14px;">{{ $t('homework.fileSizeLimitMedia') }}</span> </h3>
        <div class="add_img_box">
          <div class="add_img_item pad15" v-for="(item,index) in attach_video" :key="'video-' + index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false">
            <template v-if="item.file_id && item.download_url">
              <i class="el-icon-video-camera media-icon"></i>
              <span>{{getFileNameFromUrl(item.download_url)}}</span>
              <div class="add_model" v-show="showFileUtils == item.file_id">
                <span><i class="el-icon-view" @click="toPreView(item,3)"></i></span>
                <span style="display: inline-block;margin: 0 15px">|</span>
                <span><i class="el-icon-delete" @click="delFile(item,3)"></i></span>
              </div>
            </template>
            <template v-else>
              {{ $t('homework.transcoding') }}
            </template>
          </div>
          <div class="add_img_item">
            <el-upload
              :action="updataAction"
              :headers="headers"
              :show-file-list="false"
              accept=".mp4, .avi, .mov, .wmv, .flv, .mkv, .webm, .m4v"
              :on-progress="getProgress"
              :http-request="Upload3">
              <img style="display: block;margin: 0 auto" src="../../assets/homework/upfile.png" alt="">
              {{ $t('homework.clickUpload') }}
            </el-upload>
          </div>
        </div>
        <h3 class="myask">{{ $t('homework.addAudio') }} <span style="font-size: 14px;">{{ $t('homework.fileSizeLimitMedia') }}</span> </h3>
        <div class="add_img_box">
          <div class="add_img_item pad15" v-for="(item,index) in attach_audio" :key="'audio-' + index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false">
            <template v-if="item.file_id && item.download_url">
              <i class="el-icon-headset media-icon"></i>
              <span>{{getFileNameFromUrl(item.download_url)}}</span>
              <div class="add_model" v-show="showFileUtils == item.file_id">
                <span><i class="el-icon-view" @click="toPreView(item,4)"></i></span>
                <span style="display: inline-block;margin: 0 15px">|</span>
                <span><i class="el-icon-delete" @click="delFile(item,4)"></i></span>
              </div>
            </template>
            <template v-else>
              {{ $t('homework.transcoding') }}
            </template>
          </div>
          <div class="add_img_item">
            <el-upload
              :action="updataAction"
              :headers="headers"
              :show-file-list="false"
              accept=".mp3, .wav, .aac, .flac, .ogg, .wma, .m4a"
              :on-progress="getProgress"
              :http-request="Upload4">
              <img style="display: block;margin: 0 auto" src="../../assets/homework/upfile.png" alt="">
              {{ $t('homework.clickUpload') }}
            </el-upload>
          </div>
        </div>
        <div class="btn">
          <span class="draft" @click="submit(1)">{{ $t('homework.saveDraft') }}</span>
          <span class="submit" @click="submit(0)">{{ $t('homework.submitHomework') }}</span>
        </div>
      </div>
      <div v-else>
        <div class="submit2" v-if="homework.status == 2">
          <span class="submit recall" @click="edit = true" v-if="homework.status == 2">{{ $t('homework.recallAndEdit') }}</span>
          <div class="myhomework">
            <div>
              {{ $t('homework.myHomework') }}
              <span class="homework_btn" style="margin-left: 8px;font-weight: normal"
                    :style="{
                  backgroundColor:utils.getHomeworkColor(askDetail.status)[1],
                  color:utils.getHomeworkColor(askDetail.status)[0],
                  borderColor:utils.getHomeworkColor(askDetail.status)[0]}
          ">{{ $t(utils.getHomeworkColor(askDetail.status)[2]) }}</span>
            </div>
          </div>
          <div style="margin: 12px 0">{{askDetail.description}}</div>
          <div class="add_img_box" style="border: none;margin-top: 8px;">
            <div class="add_img_item" v-for="(item,index) in attach_jpg" :key="index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item.download_url,1)">
              <img :src="item.download_url" alt="">
            </div>
            <div class="add_img_item pad15" v-for="(item,index) in attach_doc" :key="index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item,2)">
              <template v-if="item.file_id && item.download_url">
                <img v-if="item.download_url.slice(-3).indexOf('doc') != -1" src="../../assets/homework/doc.png" alt="">
                <img v-if="item.download_url.slice(-4).indexOf('docx') != -1" src="../../assets/homework/docx.png" alt="">
                <img v-if="item.download_url.slice(-3).indexOf('pdf') != -1" src="../../assets/homework/pad_2.png" alt="">
                <span>{{getFileNameFromUrl(item.download_url)}}</span>
              </template>
              <template v-else>
                {{ $t('homework.transcoding') }}
              </template>
            </div>
            <div class="add_img_item pad15" v-for="(item,index) in attach_video" :key="'video-' + index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item,3)">
              <template v-if="item.file_id && item.download_url">
                <img src="../../assets/homework/video2.png" alt="" class="media-icon">
                <span>{{getFileNameFromUrl(item.download_url)}}</span>
              </template>
              <template v-else>
                {{ $t('homework.transcoding') }}
              </template>
            </div>
            <div class="add_img_item pad15" v-for="(item,index) in attach_audio" :key="'audio-' + index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item,4)">
              <template v-if="item.file_id && item.download_url">
                <img src="../../assets/homework/audio.png" alt="" class="media-icon">
                <span>{{getFileNameFromUrl(item.download_url)}}</span>
              </template>
              <template v-else>
                {{ $t('homework.transcoding') }}
              </template>
            </div>
          </div>
        </div>
        <div v-else class="submit3">
          <div>
            {{ $t('homework.myHomework') }}
            <span class="homework_btn" style="margin-left: 8px;font-weight: normal"
                  :style="{
                  backgroundColor:utils.getHomeworkColor(askDetail.status)[1],
                  color:utils.getHomeworkColor(askDetail.status)[0],
                  borderColor:utils.getHomeworkColor(askDetail.status)[0]}
          ">{{ $t(utils.getHomeworkColor(askDetail.status)[2]) }}</span>
          </div>
          <div style="margin: 12px 0">
            {{askDetail.description}}
          </div>
          <div class="add_img_box" style="border: none;margin-top: 8px;padding: 12px 0">
            <div class="add_img_item" v-for="(item,index) in attach_jpg" :key="index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item.download_url,1)">
              <img :src="item.download_url" alt="">
            </div>
            <div class="add_img_item pad15" v-for="(item,index) in attach_doc" :key="index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item,2)">
              <template v-if="item.file_id && item.download_url">
                <img v-if="item.download_url.slice(-3).indexOf('doc') != -1" src="../../assets/homework/doc.png" alt="">
                <img v-if="item.download_url.slice(-4).indexOf('docx') != -1" src="../../assets/homework/docx.png" alt="">
                <img v-if="item.download_url.slice(-3).indexOf('pdf') != -1" src="../../assets/homework/pad_2.png" alt="">
                <span>{{getFileNameFromUrl(item.download_url)}}</span>
              </template>
              <template v-else>
                {{ $t('homework.transcoding') }}
              </template>
            </div>
            <div class="add_img_item pad15" v-for="(item,index) in attach_video" :key="'video-' + index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item,3)">
              <template v-if="item.file_id && item.download_url">
                <img src="../../assets/homework/video2.png" alt="" @click="toPreView(item,3)" class="media-icon">
                <span>{{getFileNameFromUrl(item.download_url)}}</span>
              </template>
              <template v-else>
                {{ $t('homework.transcoding') }}
              </template>
            </div>
            <div class="add_img_item pad15" v-for="(item,index) in attach_audio" :key="'audio-' + index" @mouseenter="showFileUtils = item.file_id" @mouseleave="showFileUtils = false" @click="toPreView(item,4)">
              <template v-if="item.file_id && item.download_url">
                <img src="../../assets/homework/audio.png" alt="" class="media-icon">
                <span>{{getFileNameFromUrl(item.download_url)}}</span>
              </template>
              <template v-else>
                {{ $t('homework.transcoding') }}
              </template>
            </div>
          </div>
          <div v-if="askDetail.score">
            {{ $t('homework.teacherReview', { name: askDetail.teacher_name }) }}
          </div>
          <div style="margin: 16px 0;display: flex;align-items: center" v-if="askDetail.score">
            <img style="display: inline-block;margin-right: 16px" src="../../assets/homework/flower.png" alt="" v-for="i in askDetail.score">
            <span>{{ $t(utils.getScore(askDetail.score)) }} +{{askDetail.score}}</span>
          </div>
          <div>
            {{askDetail.teacher_description}}
          </div>
          <div class="add_img_box" style="border: none;margin-top: 8px;padding: 12px 0">
            <div class="add_img_item" v-for="(item,index) in askDetail.attach_result" :key="index" @click="toPreView(item,1)">
              <img :src="item" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noResultInfo" v-if="homeworkList && homeworkList.length == 0">
      <img src="../../assets/nodata.png" alt="">
      <p class="font_16 color_grey2" style="margin-top: 24px;">{{ $t('homework.emptyMonth') }}</p>
    </div>
    <el-dialog :visible.sync="previewDialog" custom-class="imgDialog" :fullscreen="true">
      <img :src="previewUrl" alt="">
    </el-dialog>
    <el-dialog :visible.sync="videoPreviewDialog" custom-class="mediaDialog" :fullscreen="true" append-to-body @opened="onVideoDialogOpened" @close="onMediaDialogClose('video')">
      <video
        ref="videoPlayer"
        v-if="previewUrl && videoPreviewDialog"
        :key="'video-' + previewUrl"
        controls
        preload="auto"
        :src="previewUrl"
        class="media-player needsclick"
        @error="onMediaError">
      </video>
    </el-dialog>
    <el-dialog :visible.sync="audioPreviewDialog" custom-class="mediaDialog" width="600px" append-to-body @opened="onAudioDialogOpened" @close="onMediaDialogClose('audio')">
      <audio
        ref="audioPlayer"
        v-if="previewUrl && audioPreviewDialog"
        :key="'audio-' + previewUrl"
        controls
        preload="auto"
        :src="previewUrl"
        class="audio-player needsclick"
        @error="onMediaError">
      </audio>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import axios from '@/utils/request'
export default {
  name: 'Homework',
  data(){
    return{
      value2:'',
      activeItem:'0',
      homeworkList:[],
      homework:null,
      showUtilsAttach:'',
      textarea:'',
      edit:true,
      type:1, //1图片 2文档 3视频 4音频
      accept: '.png, .jpg, .jpeg',
      maxFileSize: 10485760,
      maxMediaFileSize: 524288000,
      attach_doc:[],
      attach_jpg:[],
      attach_video:[],
      attach_audio:[],
      showFileUtils:false,
      previewDialog:false,
      videoPreviewDialog:false,
      audioPreviewDialog:false,
      previewUrl:null,
      loading:null,
      headers:null,
      updataAction:sessionStorage.getItem('uploadUrl') + '/api/homework/file/upload',
      uploadUrl: sessionStorage.getItem('uploadUrl'),
      uploadProgress:0,
    }
  },
  mounted () {
    this.getHomeworkList()
    this.uploadUrl = sessionStorage.getItem('uploadUrl')
  },
  methods:{
    getFileNameFromUrl(url) {
      // 以 '/' 分割 URL，取最后一个元素
      const parts = url.split('/');
      return parts[parts.length - 1];
    },
    resolveHomeworkMediaUrl (path) {
      if (!path) {
        return ''
      }
      if (/^https?:\/\//i.test(path)) {
        return path
      }
      const base = (this.homework && this.homework.upload_url) || this.uploadUrl || ''
      if (!base) {
        return path
      }
      return base.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '')
    },
    downloadHomeworkMedia (path) {
      const mediaUrl = this.resolveHomeworkMediaUrl(path)
      if (mediaUrl) {
        window.open(mediaUrl)
      }
    },
    Upload(file) {
      this.type = 1
      this.accept = '.png, .jpg, .jpeg'
      this.upLoading(file.file)
    },
    Upload2(file) {
      this.type = 2
      this.accept = '.doc, .docx, .pdf'
      this.upLoading(file.file)
    },
    Upload3(file) {
      this.type = 3
      this.accept = '.mp4, .avi, .mov, .wmv, .flv, .mkv, .webm, .m4v'
      this.upLoading(file.file)
    },
    Upload4(file) {
      this.type = 4
      this.accept = '.mp3, .wav, .aac, .flac, .ogg, .wma, .m4a'
      this.upLoading(file.file)
    },
    upLoading(file){
      let that = this
      this.uploadProgress = 0
      let loadingInstance = Loading.service({
        text: this.$t('homework.uploading', { progress: this.uploadProgress })
      });
      const formData = new FormData()
      let i = file.name.lastIndexOf('.')
      let t = file.name.substr(i)
      if (this.accept.indexOf(t) === -1) {
        this.$message.error(this.$t('homework.fileTypeError', { name: file.name, accept: this.accept }))
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        return
      }
      const maxSize = (this.type === 3 || this.type === 4) ? this.maxMediaFileSize : this.maxFileSize
      if (file.size > maxSize) {
        const sizeMsg = (this.type === 3 || this.type === 4)
          ? this.$t('homework.fileSizeErrorMedia', { name: file.name })
          : this.$t('homework.fileSizeError', { name: file.name })
        this.$message.error(sizeMsg)
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        return
      }
      formData.append('file', file)
      formData.append('type', this.type)

      let url = '/api/homework/file/upload'

      this.updataAction = this.uploadUrl + url

      axios.post(this.uploadUrl + url, formData,{
        onUploadProgress: (progressEvent) => {
          that.uploadProgress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          that.$set(that,'uploadProgress',that.uploadProgress)
          loadingInstance.text = this.$t('homework.uploading', { progress: this.uploadProgress })
        },
      }).then(res => {
        if (res.data.code === 200) {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          this.uploadOver(res.data.data)
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          })
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        }
      }).catch(err => {
        console.log(err)
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        this.$emit('upload-success', '')
      })
    },
    getProgress(event, file, fileList){
      console.log(event, file)
    },
    // 获取上传结果并调用更新接口
    uploadOver (tem) {
      if (!tem){
        setTimeout(() => {
          this.loading.close()
        }, 2000)
        return
      }
      tem.download_url = tem.url
      if(this.type == 1){
        this.attach_jpg.push(tem)
      }else if(this.type == 2){
        this.attach_doc.push(tem)
      }else if(this.type == 3){
        this.attach_video.push(tem)
      }else if(this.type == 4){
        this.attach_audio.push(tem)
      }
    },
    getHomeworkList(){
      this.$http.get('/api/homework?month='+this.value2).then(res => {
        if(res.data.code == 200){
          this.homeworkList = res.data.data
          if(this.homeworkList.length){
            if(this.activeItem){
              this.getHomeworkDetail(this.homeworkList[this.activeItem].id)
            }else {
              this.getHomeworkDetail(this.homeworkList[0].id)
            }
          } else {
            this.homework = null
            this.activeItem = '0'
          }
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    get_time(val) {
      this.month = val
      this.getHomeworkList()
    },
    clickHomeworkItem(item, index){
      this.activeItem = index
      this.getHomeworkDetail(item.id)
    },
    getHomeworkDetail(id){
      let loadingInstance = Loading.service();
      this.$http.get('/api/homework/detail/'+id).then(res => {
        if(res.data.code == 200){
          this.homework = res.data.data.detail
          this.askDetail = res.data.data.askList && res.data.data.askList.length ? res.data.data.askList[0] : {}
          this.attach_jpg = this.askDetail.attach_jpg ? this.askDetail.attach_jpg : []
          this.attach_doc = this.askDetail.attach_doc ? this.askDetail.attach_doc : []
          this.attach_video = this.askDetail.attach_video ? this.askDetail.attach_video : []
          this.attach_audio = this.askDetail.attach_audio ? this.askDetail.attach_audio : []
          this.edit = this.homework && this.homework.status ? (this.homework.status == 1 || this.homework.status == 5 ? true : false) : false
          this.textarea = this.askDetail.description
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    toPreView(url,type,t){
      if(type == 1){
        this.previewUrl = url
        this.previewDialog = true
      }else if(type == 3 || type == 4){
        const mediaUrl = typeof url === 'string'
          ? url
          : (url && (url.download_url || url.preview_url))
        if(mediaUrl){
          this.previewUrl = mediaUrl
          if(type == 3){
            this.videoPreviewDialog = true
          }else {
            this.audioPreviewDialog = true
          }
        }else {
          this.$message.warning(this.$t('homework.transcoding'))
        }
      }else {
        this.previewUrl = url
        if(t == 'p'){
          window.open(this.homework.preview_url)
        }else if(t == 'd'){
          window.open(this.homework.download_url)
        }else {
          if(url.preview_url){
            window.open(url.preview_url)
          }else {
            this.$message.warning(this.$t('homework.transcoding'))
          }
        }
      }
    },
    onVideoDialogOpened () {
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer
        if (video) {
          video.load()
        }
      })
    },
    onAudioDialogOpened () {
      this.$nextTick(() => {
        const audio = this.$refs.audioPlayer
        if (audio) {
          audio.load()
        }
      })
    },
    onMediaDialogClose (type) {
      const player = type === 'video' ? this.$refs.videoPlayer : this.$refs.audioPlayer
      if (player) {
        player.pause()
        player.removeAttribute('src')
        player.load()
      }
      this.previewUrl = null
    },
    onMediaError () {
      if (this.previewUrl) {
        this.$message.warning(this.$t('homework.mediaPreviewError'))
        window.open(this.previewUrl)
      }
      this.videoPreviewDialog = false
      this.audioPreviewDialog = false
      this.previewUrl = null
    },
    delFile(obj,type){
      if(type == 2){
        this.attach_doc = this.attach_doc.filter(item => item != obj)
      }else if(type == 3){
        this.attach_video = this.attach_video.filter(item => item != obj)
      }else if(type == 4){
        this.attach_audio = this.attach_audio.filter(item => item != obj)
      }else{
        this.attach_jpg = this.attach_jpg.filter(item => item != obj)
      }
      this.$set(this,'attach_jpg',this.attach_jpg)
      this.$set(this,'attach_doc',this.attach_doc)
      this.$set(this,'attach_video',this.attach_video)
      this.$set(this,'attach_audio',this.attach_audio)
    },
    submit(type){
      if(this.textarea || this.attach_jpg.length || this.attach_doc.length || this.attach_video.length || this.attach_audio.length){
        let obj = {}
        obj.description = this.textarea
        obj.file_ids_jpg = this.attach_jpg.map(item => item.file_id+'')
        obj.file_ids_doc = this.attach_doc.map(item => item.file_id+'')
        obj.file_ids_video = this.attach_video.map(item => item.file_id+'')
        obj.file_ids_audio = this.attach_audio.map(item => item.file_id+'')
        if(type){
          //草稿
          this.$http.post('/api/homework/edit/drafts/'+ this.homework.id,obj).then(res => {
            if(res.data.code == 200){
              this.getHomeworkList()
            }else {
              this.$message.error(res.data.msg)
            }
          })
        }else {
          //作业
          this.$http.post('/api/homework/submit/'+ this.homework.id,obj).then(res => {
            if(res.data.code == 200){
              this.getHomeworkList()
            }else {
              this.$message.error(res.data.msg)
            }
          })
        }
      }else {
        this.$message.error(this.$t('homework.emptySubmitError'))
      }
    }
  }
}
</script>

<style scoped lang="less">
.Homework{
  padding: 16px;
  background-color: #F8F8F8;
  min-height: calc(100vh - 110px);
  display: flex;
  flex-direction: row;
}
.homework-header{
  background-color: #fff;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 4px;
}
/deep/ .homework-month-picker.el-date-editor{
  width: 100%;
}
/deep/ .homework-month-picker .el-input__inner{
  height: 40px;
  line-height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #333;
  padding-left: 36px;
}
/deep/ .homework-month-picker .el-input__inner:focus{
  border-color: #B50604;
}
/deep/ .homework-month-picker .el-input__prefix{
  left: 8px;
  color: #909399;
}
.side_list{
  min-width: 300px;
  background-color: #fff;
  padding: 16px;
  height: calc(100vh - 135px);
  overflow-y: auto;
}
.homework_main{
  background-color: #fff;
  padding: 16px;
  margin-left: 12px;
  width: 100%;
}
.homework_box{
  margin-top: 8px;
}
.homework_item{
  height: 52px;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  box-sizing: border-box;
  cursor: pointer;
  align-items: center;
}
.homework_item p{
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.homework_btn{
  padding: 0 6px;
  min-width: 85px;  
  height: 24px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid;
  display: inline-block;
  box-sizing: border-box;
  line-height: 24px;
  text-align: center;
}
.activeItemClass{
  background-color: #FFEEE4;
  border-radius: 4px;
}
.homework_title{
  margin-top: 12px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.homework_title span {
  height: 24px;
  font-size: 12px;
  line-height: 24px;
  margin-left: 10px;
  display: inline-block;
}
.homework_time{
  margin: 12px 0;
  font-size: 14px;
  color: #666666;
  line-height: 24px;
}
.homework_des{
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  display: inline-block;
  margin-bottom: 24px;
}
.homework_study_img{
  cursor: pointer;
  position: relative;
  margin: 0;
  width: 120px;
  text-align: center;

}
.homework_attach_list{
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 24px;
  margin: 24px 0;
}
.homework_attach_thumb{
  width: 36px;
  height: 36px;
  display: block;
  border-radius: 8px;
}
.homework_media_card{
  .homework_media_icon{
    width: 120px;
    height: 120px;
    border-radius: 8px;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    box-sizing: border-box;

    i{
      font-size: 48px;
    }

    &.is-video i{
      color: #7c3aed;
    }

    &.is-audio i{
      color: #ec4899;
    }
  }
}
.homework_study_model{
  display: flex;
  position: absolute;
  background-color: #000;
  opacity: 0.5;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  color: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.homework_study_model span{
  display: inline-block;
  font-size: 14px;
}
.homework_study_model span:hover{
  color: #4B69FE;
}
.myask{
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 16px;
}
/deep/.textarea .el-textarea__inner{
  min-height: 240px !important;
}
.add_img_box{
  padding: 10px;
  width: calc(100% - 32px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border: 2px #DDDDDD dashed;
  justify-content: flex-start;
  min-width: 750px;
}
.add_img_item{
  border: 2px #DCDCDC dashed;
  width: 23.7%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  color: rgba(0, 0, 0, 0.6);
  flex-direction: column;
  cursor: pointer;
  margin-right: 10px;
  position: relative;
  word-break: break-all;
  box-sizing: border-box;
  font-size: 14px;
}
.add_img_item img{
  height: auto;
  width: auto;
  max-height: 100%;
  max-width: 100%;
  font-size: 14px;
}
.add_model{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #FFF;
}
.add_model span:hover{
  color: #4B69FE;
}
@media screen and (min-width: 1660px) {
  .add_img_item{
    height: 160px;
  }
}
@media screen and (max-width: 1660px) {
  .add_img_item{
    height: 120px;
    min-width: 160px;
  }
}
.btn{
  float: right;
  display: flex;
  margin-top: 16px;
}
.btn span{
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.draft{
  display: inline-block;
  width: 92px;
  height: 32px;
  border-radius: 4px;
  font-size: 12px;
  color: #999999;
  border: 1px solid #D6D6D6;
  background: #E5E7EB;
  margin-right: 12px;
}
.submit{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  background: #B50604;
}
.submit2{
  background-color: #FFF8F4;
  padding: 10px 16px;
  border-radius: 8px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: relative;
}
.myhomework{
  background-color: #FBF2EC;
  height: 64px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  line-height: 64px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.recall{
  width: 92px;
  height: 24px;text-align: center;line-height: 24px;position: absolute;top: -30px;right: 0;cursor: pointer;
}
.submit3{
  background-color: #FFF8F4;
  padding: 14px 16px;
}
/deep/.imgDialog{
  .el-dialog__body{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .el-dialog__close{
    font-size: 3rem;
    font-weight: bold;
  }
}
/deep/.mediaDialog{
  .el-dialog__body{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 24px;
  }
  .el-dialog__close{
    font-size: 2rem;
    font-weight: bold;
  }
  .needsclick,
  .needsclick *{
    touch-action: manipulation;
  }
}
.media-player{
  max-width: 100%;
  max-height: calc(100vh - 120px);
}
.audio-player{
  width: 100%;
  min-height: 54px;
  outline: none;
}
.media-icon{
  font-size: 48px;
  color: #666;
  margin-bottom: 8px;
}
.noResultInfo {
  margin-top: 80px;
  text-align: center;
  width: 100%;
  p {
    margin-bottom: 32px;
  }
}
.pad15{
  padding: 15px;
  box-sizing: border-box;
}
</style>
<style lang="less">
.homework-date-popper{
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Homework.vue